export default __webpack_public_path__ + "static/media/annapurna.4a8f347c.jpg";